import styled from 'styled-components';
import { media, zIndex } from '../css';

export const StyledModalInternal = styled.div`
  && {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: ${props => props.width};
    height: ${props => props.height};
    max-height: 100%;
    ${media.lessThan('md')`width: 100%; height: 100%;`};
    max-width: 80%;
    background: ${props => props.bgColor};
    outline: none;
    overflow-y: auto;
    overflow-x: ${props => (props.disableHorizontalScroll ? 'hidden' : 'auto')};
    -webkit-overflow-scrolling: touch;
  }
`;

export const StyledCloseButtonWrapper = styled.span`
  position: absolute;
  top: 0;
  right: 0;
  padding: 27px;
  cursor: pointer;
  z-index: ${zIndex.modal};

  & > figure {
    cursor: pointer;
  }
`;
